import preview from './preview.vue';
export default {
  components: {
    preview
  },
  data() {
    return {
      dialogVisible: false,
      templateControlsGroupId: '',
      customerInsuranceId: '',
      insuranceId: '',
      linkType: '',
      insureLink: ''
    };
  },
  methods: {
    init(customerInsuranceId, insuranceId, templateControlsGroupId, linkType, insureLink) {
      console.log(customerInsuranceId, insuranceId, templateControlsGroupId, linkType);
      this.templateControlsGroupId = templateControlsGroupId;
      this.customerInsuranceId = customerInsuranceId;
      this.insuranceId = insuranceId;
      this.linkType = linkType;
      this.insureLink = insureLink;
      this.dialogVisible = true;
    }
  }
};